import { z, ZodEffects, ZodString } from 'zod';

export const requiredString = () => z.string().trim().min(1, { message: 'Required' });

// Used as an extension: Needed to make sure that the min check is done on actual values
export function minRefine(
  this: z.ZodString | ZodEffects<ZodString, string, string>,
  min: number
): ZodEffects<ZodString, string, string> {
  return this.refine((val) => (val ? val.length >= min : true), {
    message: `Cannot have less than ${min} characters`
  }) as ZodEffects<ZodString, string, string>;
}

// Used as an extension:  Needed to make sure that regex is only run on actual values
export function regexRefine(
  this: z.ZodString | ZodEffects<ZodString, string, string>,
  regex: RegExp,
  options?: { message: string }
): ZodEffects<ZodString, string, string> {
  return this.refine((val) => (val ? regex.test(val) : true), {
    message: options?.message ?? 'The input does not match the expected format'
  }) as ZodEffects<ZodString, string, string>;
}
